import { SymbolType } from "@lib/titan2-slingo/dist/api/model/enum/SymbolType";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { TotalWinCounter } from "@lib/titan2-slingo/dist/game/view/abstract/display/TotalWinCounter";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import gsap, { Linear } from "gsap";
import { GameEvent, GameTestEvent } from "../../../controller/event/GameEvent";
export class GameTotalWinCounter extends TotalWinCounter {
    constructor() {
        super(...arguments);
        this.currentValue = 0;
        this.currentTarget = 0;
    }
    create() {
        super.create();
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.REELS_COMPLETE, this.handleWinUpdate);
        this.registerGame(SlingoEvent.SLINGO_COMPLETE, this.handleWinUpdate);
        this.registerGame(GameTestEvent.TOTAL_WIN_UPDATE, this.handleWinUpdate);
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(GameEvent.COIN_WIN_UPDATE_TOTAL, this.handleCoinWinCountEnd);
        this.registerGame(CommonGameEvent.RECOVERY, this.handleRecovery);
    }
    handlePurchaseEntry() {
        this.currentValue = 0;
        this.currentTarget = 0;
        this.updateValue("");
    }
    handleRecovery() {
        if (!Service.isReplay()) {
            const totalWin = this.model.getTotalWin();
            this.currentValue = totalWin;
            this.currentTarget = totalWin;
            this.updateValue(totalWin > 0 ? this.formatCurrency(totalWin) : "");
        }
    }
    handleWinUpdate() {
        const totalWin = this.model.getTotalWin();
        if (totalWin === 0) {
            this.currentValue = 0;
            this.currentTarget = 0;
            this.updateValue("");
        }
        else {
            this.countUp(this.currentValue, totalWin);
        }
    }
    countUp(startValue, endValue, duration = 0.5) {
        if (startValue === endValue) {
            return;
        }
        if (endValue === this.currentTarget) {
            return;
        }
        if (duration === 0) {
            this.updateValue(this.formatCurrency(endValue));
            return;
        }
        this.currentValue = startValue;
        this.currentTarget = endValue;
        gsap.to(this, {
            currentValue: endValue,
            duration,
            ease: Linear.easeNone,
            onUpdate: () => {
                this.updateValue(this.formatCurrency(this.currentValue));
            }
        });
    }
    updateValue(text) {
        this.valueField.setText(text, true);
    }
    handleScatterWinCountEnd() {
        const totalWin = this.model.getTotalWin();
        const coinWinSymbolResult = this.model.getSpinResult().getSymbolWins().find(win => win.getType() === SymbolType.COIN);
        const coinWinAmount = coinWinSymbolResult ? coinWinSymbolResult.getAmount() : 0;
        const postScatterWinAmount = totalWin - coinWinAmount;
        if (postScatterWinAmount > 0) {
            this.countUp(this.currentValue, postScatterWinAmount);
        }
    }
    handleCoinWinCountEnd() {
        const totalWin = this.model.getTotalWin();
        if (totalWin > 0) {
            this.countUp(this.currentValue, totalWin);
        }
    }
}
//# sourceMappingURL=GameTotalWinCounter.js.map